"use client";
import React from "react";
import PropTypes from "prop-types";
import { Grid, Popup, Button } from "semantic-ui-react";
import { Title, ImageItem } from "../../components";
import parse from "html-react-parser";

const options = {
  replace: (domNode) => {
    if (domNode.attribs && domNode.attribs.class === "remove") {
      return <></>;
    }
  },
};

const IconsGrid = ({ gridData, onscoreclick, isMobile }) => (
  <div className="grid_container">
    <ul className="nh_icon_grid_ul">
      {gridData &&
        gridData.map((grid, index) => (
          <Popup
            key={index}
            className="right_content_top_popup"
            size="mini"
            on="hover"
            //content=
            trigger={
              <li
                className={`${
                  grid.isUndervalue && grid.isUndervalue != "-"
                    ? "valueditem"
                    : ""
                } grid_item`}
              >
                <ImageItem
                  centered
                  source={grid.HeaderImage}
                  alt="Neighborhood Factors"
                  title="Neighborhood Factors"
                  height={isMobile ? "39.23" : "46.15"} // 46.15 reduced by 15% is 39.23
                  width={isMobile ? 51 : 60} // 60 reduced by 15% is 51
                />
                {grid.title && (
                  <div
                    className="ui small center aligned"
                    style={{
                      color: grid.txtColor,
                      fontSize: "13px",
                    }}
                  >
                    {grid.title}
                  </div>
                )}
                <div
                  className="ui small center aligned header"
                  style={{
                    color: "rgb(15, 20, 67)",
                    letterSpacing: "0.3px",
                    margin: "0px 7px",
                  }}
                >
                  {grid.link && grid.link !== "" && grid.link !== "safety" ? (
                    <a onClick={() => onscoreclick(grid)}>
                      {grid.SubContent}/5
                    </a>
                  ) : grid.isUndervalue &&
                    grid.isUndervalue != "-" &&
                    grid.isUndervalue !== "" ? (
                    <span
                      className={
                        grid.isUndervalue > 0
                          ? "overvalue_txt"
                          : "undervalue_txt"
                      }
                    >
                      {grid.SubContent}
                    </span>
                  ) : grid.tooltiptext ===
                    "Neighborhood weighted Appreciation" ? (
                    <span
                      className={
                        grid.SubContent > "0%"
                          ? "undervalue_txt"
                          : grid.SubContent != "-" &&
                            grid.SubContent != "0%" &&
                            "overvalue_txt"
                      }
                    >
                      {grid.SubContent != "-" ? grid.SubContent : "-"}
                    </span>
                  ) : grid.link === "safety" ? (
                    grid.SubContent + "/5"
                  ) : (
                    grid.SubContent
                  )}
                  {grid.appreciationCityFlag || grid.medianPriceDomCityFlag ? (
                    <sup style={{ left: "2px" }}>(2)</sup>
                  ) : (
                    ""
                  )}
                  {grid.amenitiesFlag ? (
                    <a onClick={() => onscoreclick(grid)}>
                      <sup style={{ left: "2px" }}>(1)</sup>
                    </a>
                  ) : (
                    ""
                  )}

                  {/* {grid.isUndervalue &&
                grid.isUndervalue != "-" &&
                grid.isUndervalue !== "" ? (
                  <p
                    className={
                      grid.isUndervalue > 0 ? "overvalue" : "undervalue"
                    }
                  >
                    {grid.isUndervalue > 0 ? "Overvalued" : "Undervalued"}
                  </p>
                ) : (
                  ""
                )} */}
                </div>
              </li>
            }
            // hoverable
          >
            {parse(grid.tooltiptext, options)}
          </Popup>
        ))}
    </ul>
  </div>
);

IconsGrid.propTypes = {
  gridData: PropTypes.array.isRequired,
};

export default IconsGrid;
